.root {
    display: contents;
}

/*
 * A hold on a coarse pointer is this component's right click, and the platform
 * has its own ideas about what a hold means: iOS raises the callout and both
 * platforms start a text selection. Scoped to `pointer: coarse` so a mouse user
 * keeps ordinary selection over the same content.
 */
@media (pointer: coarse) {
    .root {
        -webkit-touch-callout: none;
        user-select: none;
    }
}

/*
 * The menu takes focus when it opens so a screen reader announces it, and that
 * focus gets no ring of its own: measured in Chrome, focusing it from a long
 * press still matches `:focus-visible`, which drew a heavy ring around the whole
 * menu after every touch. The indicator that matters is on the focused item,
 * which is where the arrow keys move next.
 */
.menu:focus {
    outline: none;
}

.menu {
    position: fixed;
    z-index: var(--tempest-z-popover);
    min-width: 180px;
    max-width: 320px;
    background-color: var(--tempest-bg);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-radius-lg);
    box-shadow: var(--tempest-shadow-lg);
    padding: var(--tempest-space-1);
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-text-base);
    list-style: none;
    margin: 0;
    animation: tempest-context-menu-in var(--tempest-duration-fast) var(--tempest-ease-out);
}

.item {
    display: flex;
    align-items: center;
    gap: var(--tempest-space-2);
    width: 100%;
    padding: var(--tempest-space-2) var(--tempest-space-3);
    background: none;
    border: none;
    border-radius: var(--tempest-radius-sm);
    color: var(--tempest-text);
    font-family: inherit;
    font-size: inherit;
    line-height: var(--tempest-leading-snug);
    text-align: left;
    cursor: pointer;
    transition: var(--tempest-transition-color);
}

@media (hover: hover) and (pointer: fine) {
    .item:hover:not(:disabled) {
        background-color: var(--tempest-surface);
    }
}

.item:focus,
.item.active {
    outline: none;
    background-color: var(--tempest-primary-soft);
    color: var(--tempest-primary-on-soft);
    box-shadow: inset 3px 0 0 0 var(--tempest-selected-indicator);
}

.item:disabled {
    opacity: 0.55;
    cursor: not-allowed;
}

.item.danger {
    color: var(--tempest-danger);
}

.separator {
    height: 1px;
    background-color: var(--tempest-border);
    margin: var(--tempest-space-1) 0;
}

@keyframes tempest-context-menu-in {
    from {
        opacity: 0;
        transform: scale(0.96);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

@media (prefers-reduced-motion: reduce) {
    .menu {
        animation: none;
    }
}
